import Load from '../../../base/page/'
import Message from '../../../base/message/'
import { t } from '../../../../locale/'
export default {
    inject: ['root'],
    props: {
        keyword: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            list: [],
            loading: false,
            hasMore: true,
            page: 1,
            size: 10,
        }
    },
    components: {
        Load  
    },
    methods: {
        handleChecked(checked, data) {
            if(checked && 1 + this.root.selectedCount > this.root.limit) {
                return Message.warning(t('selectMember.maximum'))
            }
            data.checked = checked
            this.$emit('handleSelected', data)
        },
        handleError(params) {
            if(!params) {
                this.loading = false
                this.hasMore = true
            }
            params && (params.expand = false)
            params && (params.loading = false)
            params && (params.children = [])
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/business/select-member/mixins/section.js